import { render, staticRenderFns } from "./CustomerProductReviewModal.vue?vue&type=template&id=5a38ab49&"
import script from "./CustomerProductReviewModal.vue?vue&type=script&lang=ts&"
export * from "./CustomerProductReviewModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports